export default {"src":"/_next/static/media/dropdown.1f180111.svg","height":4,"width":7,"blurWidth":0,"blurHeight":0};